import styled from "styled-components";

export const BuyContainer = styled.div`
height: 850px;
background: transparent;


@media screen and (max-width: 1365px) {
    height: 750px;
}
@media screen and (max-width: 768px) {
    height: 550px;
}

@media screen and (max-width: 720px) {
    height: 600px;
}

@media screen and (max-width: 650px) {
    height: 700px;
}

@media screen and (max-width: 420px) {
    height: 800px;
}

@media screen and (max-width: 380px) {
    height: 870px;
}

@media screen and (max-width: 300px) {
    height: 950px;
}

@media screen and (max-width: 250px) {
    height: 1050px;
}

`

export const BuyWrapper = styled.div`
    display: grid;
    width: 100%;
    max-width: 1100px;    
    justify-content: center;
    z-index: 20;
    
`

export const BuyRow = styled.div`
    
    display: grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    justify-items: center;
    grid-template-areas: ${({imgStart}) => 
    (imgStart? `'col2 col1'` : `'col1 col2'`)};

    @media screen and (max-width: 1365px) {
    grid-template-areas: ${({imgStart}) => 
    (imgStart? `'col1' 'col2'`: `'col1 col1' 'col2 col2'`)};
    }
`

export const Column1 = styled.div`
    
    margin-bottom: 150px;
    grid-area: col1;
    width: 40vw;
    z-index: 0;
    display: flex;
    flex-direction: column;
`

export const Column2 = styled.div`
    margin-top: 10px;
    margin-bottom: 15px;
    padding:  0 15px;
    grid-area: col2;
    width: 40vw;
    z-index: 0;
`

export const TextWrapper = styled.div`
    max-width: 540px;
    display: flex;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0px;
    justify-content: center;
    text-align: center;
    flex-direction: column;
`

export const TopLine = styled.p`
    display: flex;
    justify-content: center;
    color: #fff;
    font-size: 60px;
    line-height: 100%;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    font-family: 'Gemunu Libre', sans-serif;
    animation-name: animate;
    animation-duration: 5s;
    animation-iteration-count: infinite;

    @media screen and (max-width: 768px) {
    font-size: 2em;

    @keyframes animate
    {
        0%, 20%, 26%, 35%{
            color: #0e3742;
            text-shadow: none;
        }
        10%, 22%, 30%, 50%, 100%
        {
            color: #fff;
            text-shadow: 0 0 10px #03bcf4,
            0 0 20px #03bcf4,
            0 0 40px #03bcf4,
            0 0 80px #03bcf4,
            0 0 160px #03bcf4;
        }
    }
}
`

export const Subtitle = styled.p`
    max-width: 440px;
    font-size: 22px;
    line-height: 35px;
    font-weight: 900;
    color: ${({darkText}) => (darkText ? '#010606' : "#fff")};
    font-family: 'Gemunu Libre', sans-serif;

    @media screen and (max-width: 768px) {
    font-size: 2vh;
}
`

export const BuyP = styled.p`
    color: white;
    font-size: 20px;
    font-family: 'Gemunu Libre', sans-serif;
    
`

export const ImgWrap = styled.div`
    max-width: 555px;
    height: 80vh;
    margin-left: 20%;

    @media screen and (max-width: 1365px) {
    
    display: none;
}
`

export const BuySocial = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    
    justify-items: center;
`

export const TextWrapper2 = styled.div`
    color: black;
    
    font-size: 3rem;
    justify-content: center;
    align-items: center;
    display: flex;
    box-shadow: rgba(0, 0, 0, 0.5) 20px 20px 50px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 20px;
    text-align: center;
    z-index: 99;
    font-family: 'Gemunu Libre', sans-serif;

    @media screen and (max-width:1453px){
        font-size: 5vh;
        width: 100%;
    }
`

export const TextWrapper4 = styled.button`

    font-size: 25px;
    text-align: center;
    color: white;
    background: transparent;
    box-shadow: 0 0px 30px rgba(255, 255, 255, 1);
    border-radius: 10px;
    margin-top: 50px;
    transition: 0.5s;
    font-family: 'Gemunu Libre', sans-serif;
    
    z-index: 99;

    &:hover{
        transform: scale(1.2);
        transition: 0.5s;
        color: #fff;
    text-shadow: 0 0 10px #03bcf4,
    0 0 20px #03bcf4,
    0 0 40px #03bcf4,
    0 0 80px #03bcf4,
    0 0 160px #03bcf4;
    }

`

export const ImgWrap2 = styled.div`
    
    height: 300px;
    width: auto;
    
    margin-left: 30%;
    z-index: 0;
    display: none;

    @media screen and (max-width: 1365px) {
    display: flex;
    opacity: 0.3;
    transform: translateY(-550px);
    display: flex;
    justify-content: center;
    margin: 0 auto;
    height: 40vh;
    width: 10px;
    
}
`